import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import CategoryFilter from '@/redux/category/CategoryFilter';
import useSearchParamActions from '@/customHooks/useSearchParamActions';
import PostsFilterByDate from '@/redux/post/PostsFilterByDate';
import ToolTypeFilter from '@/redux/post/ToolTypeFilter';
import PartnerFilter from '@/redux/post/PartnerFilter';

function FilterBar() {
  const { getAllSearchParams, removeSearchParam, removeAllSearchParams } =
    useSearchParamActions();
  const searchParams = getAllSearchParams();
  const filterParams = ['category', 'postedAt', 'author', 'toolType'];
  const { appendSearchParam } = useSearchParamActions();

  const filterSearchParams = searchParams.filter((param) =>
    filterParams.includes(param.key)
  );

  return (
    <div className="w-full space-y-4 py-5">
      <div className="flex flex-wrap items-center gap-2">
        <PostsFilterByDate />
        <CategoryFilter />
        <ToolTypeFilter />
        <PartnerFilter />
        <Button
          variant="default"
          onClick={() => appendSearchParam('author', 'onefinity')}
        >
          Onefinity
        </Button>
      </div>

      {filterSearchParams.length > 0 && <Separator className="my-2" />}

      <div className="flex flex-wrap items-center gap-2">
        {filterSearchParams.map((param) => {
          return param.value.map((value) => {
            return (
              <Button
                key={value}
                variant="secondary"
                size="sm"
                className="gap-2"
              >
                {value}
                <X
                  className="h-4 w-4"
                  onClick={() => removeSearchParam(param.key, value)}
                />
              </Button>
            );
          });
        })}
        {filterSearchParams.length > 1 && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => removeAllSearchParams(filterParams)}
          >
            Clear All
          </Button>
        )}
      </div>
    </div>
  );
}

export default FilterBar;
